(function ($) {

	$(".product-slider").each(function () {
		var $this = $(this);
		var Products = new Swiper($this.find('.swiper-container')[0], {
			slidesPerView: 2,
			loop: false,
			spaceBetween: 10,
			freeMode: true,
			watchOverflow: true,
			mousewheel: {
				forceToAxis: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			scrollbar: {
				el: ".swiper-scrollbar",
				hide: false,
				draggable: true,
			},
			breakpoints:{
				767: {
					freeMode: false,
					slidesPerView: 3,
				},
				968: {
					freeMode: false,
					slidesPerView: 4,
					spaceBetween: 20,
				},
			}
		});
		window.onresize = function () {
			Products.update();
		}
	});

})(jQuery);
